import { updateGlobalPayment } from '@/api/tablet';
import { useMutation } from 'react-query';

const useUpdateGlobalPayment = (userId: string, tabletId: string) => {
  return useMutation({
    mutationFn: ({
      paymentId,
      newState,
      paymentAmount,
      refundId,
      cashAmount,
      cardAmount,
    }: {
      paymentId: string;
      newState: string;
      paymentAmount: number;
      refundId?: string;
      cashAmount?: number;
      cardAmount?: number;
    }) =>
      updateGlobalPayment(
        userId,
        tabletId,
        paymentId,
        newState,
        paymentAmount,
        refundId,
        cashAmount,
        cardAmount,
      ),
  });
};

export default useUpdateGlobalPayment;
